import script from "./ViewBudgetsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBudgetsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewBudgetsPage.vue?vue&type=style&index=0&id=b062ef52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b062ef52"]])

export default __exports__